import React from 'react';
import PropTypes from 'prop-types';

export const IconError = ({ className }) => (
  <svg className={className} width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M51.2132 8.78672C45.5469 3.12059 38.0133 0 30 0C21.9866 0 14.4529 3.12059 8.78672 8.78672C3.12047 14.453 0 21.9867 0 30C0 38.0133 3.12047 45.5469 8.78672 51.2132C14.453 56.8794 21.9866 60 30 60C38.0133 60 45.5469 56.8794 51.2132 51.2132C56.8794 45.5469 60 38.0133 60 30C60 21.9867 56.8794 14.4531 51.2132 8.78672ZM30 56.4844C15.3964 56.4844 3.51562 44.6036 3.51562 30C3.51562 15.3964 15.3964 3.51562 30 3.51562C44.6036 3.51562 56.4844 15.3964 56.4844 30C56.4844 44.6036 44.6036 56.4844 30 56.4844ZM36.7762 21.283C37.4271 20.6321 38.4824 20.6321 39.1332 21.283C39.7841 21.9338 39.7841 22.9891 39.1332 23.64L32.357 30.4162L39.1337 37.1929C39.7846 37.8438 39.7846 38.899 39.1337 39.5499C38.4828 40.2008 37.4275 40.2008 36.7767 39.5499L30 32.7732L23.2233 39.5499C22.5725 40.2008 21.5172 40.2008 20.8663 39.5499C20.2154 38.899 20.2154 37.8438 20.8663 37.1929L27.643 30.4162L20.8668 23.64C20.2159 22.9891 20.2159 21.9339 20.8668 21.283C21.5176 20.6321 22.5729 20.6321 23.2238 21.283L30 28.0592L36.7762 21.283Z" fill="#EE102B" />
  </svg>

);

IconError.propTypes = {
  className: PropTypes.string,
};

IconError.defaultProps = {
  className: null,
};
